// extracted by mini-css-extract-plugin
export default {"createEditTemplateContainer":"CreateEditMedicationTemplate_createEditTemplateContainer__Uxd3D"};